/* eslint react/forbid-prop-types:0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

function preloadImg(src, cb) {
  const img = new window.Image();
  img.onload = cb;
  img.src = src;
}

export default class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: !props.lazyLoad,
    };
  }

  componentDidMount() {
    const { src } = this.props;
    if (!this.state.loaded) {
      preloadImg(src, this.handleLoad);
    }
  }

  handleLoad = () => {
    this.setState({ loaded: true });
    if (this.props.onLoad) {
      this.props.onLoad();
    }
  };

  handleError = () => {
    this.setState({ loaded: false });
  };

  render() {
    const { alt, className, renderPlaceholder, src, srcSet, style } = this.props;

    const imageSrcSet = srcSet;
    if (!this.state.loaded) {
      return <span>{renderPlaceholder()}</span>;
    } else if (this.props.useBackgroundImage) {
      const divImgStyle = {
        ...style,
        ...{ backgroundImage: 'url(' + src + ')', backgroundSize: 'cover' },
      };
      return (
        <div
          className={className}
          onError={this.handleError}
          onLoad={this.handleLoad}
          style={divImgStyle}
        />
      );
    } else {
      const optionalProps = {};
      if (imageSrcSet) {
        optionalProps.srcSet = imageSrcSet;
      }

      return (
        <img
          alt={alt}
          className={className}
          onError={this.handleError}
          onLoad={this.handleLoad}
          src={src}
          style={style}
          {...optionalProps}
        />
      );
    }
  }
}

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  lazyLoad: PropTypes.bool,
  onLoad: PropTypes.func,
  renderPlaceholder: PropTypes.func,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string,
  style: PropTypes.object,
  useBackgroundImage: PropTypes.bool,
};

Image.defaultProps = {
  useBackgroundImage: false,
  lazyLoad: true,
};
